/** Panneau formulaire 640px — Figma Paramètres généraux (2552-35684) */
const ConstantsFormPanel = ({ title, children }) => (
  <div className="settings-constants-panel">
    <div className="settings-constants-panel__header">
      <h4 className="settings-constants-panel__title">{title}</h4>
    </div>
    <div className="settings-constants-panel__body">{children}</div>
  </div>
);

export default ConstantsFormPanel;
